import React, { FC } from 'react';
import { Carousel } from '@goldbely/explore-component-library';

import { ICollection } from 'src/prize/types/shoppe';

import { Collection } from './atoms/Collection';

import styles from './index.module.sass';

interface IHogIslandOysterCoProps {
  activeCollectionId?: number;
  collections: ICollection[];
}

export const HogIslandOysterCo: FC<IHogIslandOysterCoProps> = ({
  activeCollectionId,
  collections,
}) => (
  <div className={styles.container}>
    <Carousel classNames={{ container: styles.carousel }} element="ul" showSteppers={false}>
      {collections.map(( collection ) => (
        <li className={styles.item} key={collection.id}>
          <Collection data={collection} isActive={collection.id === activeCollectionId} />
        </li>
      ))}
    </Carousel>
  </div>
);
